import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// Force rebuild trigger update
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Input from "../common/Input";
import RadioButton from "../common/Radio_button";
import Select from "../common/Select";
import disable_link from "../../svg/disable_link.svg";
import active_link from "../../svg/active_link.svg";
import active_check from "../../svg/verifiedCheck.svg";
import active_info from "../../svg/info_grey.svg";
import { Link } from "react-router-dom";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
import OtherSubject from "../OtherSubject/OtherSubject";
import { GetUrlverified } from "../../containers/autherFlow/personalDetails/queries";
import { checkUrl, verifyMsg, getJournalDisciplineName, getUnique } from "../../utils";
import ToolTip from "../common/ToolTip";
import { countryOptions } from "../../constants/Countries";
import { getSubjectSpecialization } from "../../store/apiCalls/profileDetails";

function WorkSection(props) {
  const {
    val,
    ind,
    handleChange,
    StateJson,
    activeTab,
    heading,
    Sectionindex,
    otherSpecialization = [],
    workSectionValues,
    masterData,
    specializationsData,
    setWorkSection,
    workSection,
    profileDetails,
    journalsList = [],
    errorObj = {},
    renderLinks,
  } = props;

  const autoDisciplineForJournal = Sectionindex === 0 && profileDetails?.journalName
    ? getJournalDisciplineName(profileDetails.journalName, journalsList, masterData)
    : "";
  const isJournalDisciplineAutoSet = !!autoDisciplineForJournal;

  const [subjectId, setSubjectId] = useState("");
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [showSubject, setShowSubject] = useState(false);
  const [other, setOther] = useState({
    show: false,
    specialization: "",
    disabled: true,
  });

  const handleOtherSubject = () => {
    props.handleGetSpecialization();
  };

  const getSubjectId = (subject) => {
    return masterData?.MasterData?.subjectdata?.find(
      (sub) => subject === sub?.subjectName
    )?._id;
  };

  const otherSubject = useSelector(
    (state) => state?.ProfileReducer?.otherSubject
  );
  const [countryArray, setCountryArray] = useState([]);
  const [isurlValid, setIsUrlValid] = useState(workSectionValues?.URL ?? false);
  const [url, setUrl] = useState(workSectionValues?.URL);
  const verifiedURl = async (sucess) => {
    const cloneWorkSection = [...workSection];
    const verifyUrlpdateWorkSection = cloneWorkSection.map((item, index) => {
      if (ind === index) {
        return { ...item, error: "", URL: url, verified: true };
      }
      return item;
    });
    setWorkSection(verifyUrlpdateWorkSection);
    setIsUrlValid(true);
    props.setValidationError(ind);
  };

  const { mutate: verifyURL } = GetUrlverified(
    verifiedURl,
    setWorkSection,
    workSection,
    ind
  );
  useEffect(() => {
    setUrl(workSectionValues?.URL);
    setIsUrlValid(!workSectionValues?.URL ? false : true);
  }, [workSectionValues?.URL]);

  const onIconClick = (e) => {
    if (e.target.innerText === "Edit") {
      setIsUrlValid(false);
    } else {
      const verified = checkUrl(url);
      if (verified) {
        verifyURL({ url: url });
      } else {
        const cloneWorkSection = [...workSection];
        const updateWorkSection = cloneWorkSection.map((item, index) => {
          if (ind === index) {
            return { ...item, error: "Please add a valid url" };
          }
          return item;
        });
        setWorkSection(updateWorkSection);
      }
    }
  };

  const handleSelectValue = (value, Sectionindex, name) => {
    props.handleSelectChange(value, Sectionindex, name);
  };

  const handleUrlChange = (e, ind) => {
    setIsUrlValid(false);
    if (workSectionValues.verified) {
      const cloneWorkSection = [...workSection];
      const updateWorkSection = cloneWorkSection.map((item, index) => {
        if (ind === index) {
          return { ...item, verified: false };
        }
        return item;
      });
      setWorkSection(updateWorkSection);
    }
    setUrl(e.target.value);
  };

  const HandleCancleVerifying = () => {
    setIsUrlValid(true);
    setUrl(workSectionValues?.URL);
    const cloneWorkSection = [...workSection];
    const updateWorkSection = cloneWorkSection.map((item, index) => {
      if (ind === index) {
        return { ...item, verified: true, error: "" };
      }
      return item;
    });
    setWorkSection(updateWorkSection);
  };

  const isProfessional = activeTab === "professional";
  const isRequired = (value = "") => {
    return Sectionindex === 0 ||
      workSectionValues?.url ||
      workSectionValues?.universitySchoolCompany
      ? true
      : false;
  };

  const getClasses = (classes = "", name = "") => {
    return errorObj[name] ? `errored ${classes}` : classes;
  };

  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = () => {
    return setCountryArray(countryOptions.map((val) => val?.key).sort());
  };

  const removeOthers = () => {
    const record = masterData?.MasterData?.subjectdata?.find(
      (a) => a.subjectName === workSectionValues?.subject
    );
    setSubjectId(record ? record?._id : "");
  };

  const getSubSpecialization = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      subjectId: subjectId,
    };
    const response = await getSubjectSpecialization(headers, params);
    if (response?.status === 200) {
      let newRecord = response?.data?.data?.data;
      if (ind === 0) {
        return setSubjectOptions(
          newRecord ? newRecord?.map((spec) => spec?.specialization) : []
        );
      } else {
        return setSubjectOptions(
          newRecord
            ? newRecord
                ?.filter(
                  (spec) =>
                    spec?.specialization !==
                    "Other Subject (choose this option to register your subject)"
                )
                .map((spec) => spec?.specialization)
            : []
        );
      }
    } else return;
  };

  useEffect(() => {
    if (workSectionValues?.subject) {
      removeOthers();
    }
  }, [workSectionValues]);

  useEffect(() => {
    if (subjectId) {
      getSubSpecialization();
    }
  }, [subjectId]);

  const [urlWarningMsg, setUrlWarningMsg] = useState("");

  const getAffiliationTypeLabel = () => {
    if (workSectionValues?.heading === "Primary Affiliation") {
      return workSectionValues?.affiliationType || "University";
    }
    return workSectionValues?.affiliationType || "university/Institute/company/hospital";
  };

  const handleUnverifiedClick = () => {
    if (!isurlValid) {
      if (!url || url.trim() === "") {
        setUrlWarningMsg("* Please enter the URL");
      } else {
        setUrlWarningMsg("* Please verify the URL");
      }
      const urlInputs = document.getElementsByName("URL");
      if (urlInputs && urlInputs[Sectionindex]) {
        urlInputs[Sectionindex].focus();
      }
    }
  };

  return (
    <>
      <div className="affiliation-card mb-4 position-relative">
        <span className="affiliation-card-label">
          {heading} {heading === "Primary Affiliation" && <span className="text-danger">*</span>}
        </span>


        <div className="form-fields-grid row">
          {workSectionValues.heading === "Primary Affiliation" && (
            <div className="col-lg-12 mb-2 text-start">
              <span className="text-danger d-block mb-0" style={{ fontSize: '13px', fontWeight: 'bold' }}>*</span>
              <div
                className={getClasses("affiliation-options horizontal-radios", "affiliationType")}
              >
                <RadioButton
                  label="University"
                  name="affiliationType"
                  id="University"
                  checked={!workSectionValues.affiliationType || workSectionValues.affiliationType === "University"}
                  handleChange={(e) => handleChange(e, Sectionindex)}
                  required={isProfessional}
                />
                <RadioButton
                  label="Institute"
                  name="affiliationType"
                  id="Institute"
                  checked={workSectionValues.affiliationType === "Institute"}
                  handleChange={(e) => handleChange(e, Sectionindex)}
                  required={isProfessional}
                />
                <RadioButton
                  label="Company"
                  name="affiliationType"
                  id="Company"
                  checked={workSectionValues.affiliationType === "Company"}
                  handleChange={(e) => handleChange(e, Sectionindex)}
                  required={isProfessional}
                />
                <RadioButton
                  label="Hospital"
                  name="affiliationType"
                  id="Hospital"
                  checked={workSectionValues.affiliationType === "Hospital"}
                  handleChange={(e) => handleChange(e, Sectionindex)}
                  required={isProfessional}
                />
              </div>
            </div>
          )}

          <div className="col-lg-12 mb-4">
                <div
                  className={`position-relative py-2 ${getClasses(
                    "",
                    "universitySchoolCompany"
                  )}`}
                >
                  <Input
                    className={
                      workSectionValues?.universitySchoolCompany
                        ? "form-control active-input"
                        : "form-control grey-input"
                    }
                    labelClass=""
                    label={"Name of " + getAffiliationTypeLabel() + "*"}
                    placeholder={"Name of " + getAffiliationTypeLabel() + "*"}
                    name="universitySchoolCompany"
                    type="text"
                    value={workSectionValues?.universitySchoolCompany}
                    handleChange={(e) => handleChange(e, Sectionindex)}
                    required={
                      isProfessional &&
                      isRequired(workSectionValues?.universitySchoolCompany)
                    }
                  />
                </div>
              </div>

              <div className="col-lg-12 mb-4">
                <div
                  className={`position-relative py-2 verify-link-wrapper ${workSectionValues?.error
                    ? getClasses("verify-link op", "url")
                    : getClasses("verify-link", "url")
                  }`}
                >
                  <Input
                    type="text"
                    errors={workSectionValues?.error}
                    className={
                      url
                        ? "form-control active-input with_icon"
                        : "form-control grey-input with_icon"
                    }
                    placeholder={"URL of " + getAffiliationTypeLabel() + "*"}
                    name="URL"
                    handleChange={(e) => handleUrlChange(e, Sectionindex)}
                    label={"URL of " + getAffiliationTypeLabel() + "*"}
                    value={url}
                    labelClass=""
                    postIconClass={val.verified ? active_check : null}
                    preIconClass={url ? active_link : disable_link}
                    postTextClass={
                      !isurlValid
                        ? `<span style='padding: 0 18px;'><Link to='#' >Verify</Link> </span>`
                        : `<span style='padding: 0px 25px 0px 0px;'><Link to='#' >EDIT</Link> </span>`
                    }
                    onIconClick={onIconClick}
                    required={isProfessional && isRequired(url)}
                  />
                  {!isurlValid && (
                    <ToolTip
                       classNameTooltip="personaldetails-tooltip"
                       toolTipMessage={verifyMsg()}
                    >
                      <img
                        className="inner-link pe-cursor ps-1"
                        src={active_info}
                        alt="no img"
                        style={{ position: 'absolute', right: '80px', top: '1.3rem', zIndex: 11 }}
                      />
                    </ToolTip>
                  )}
                  <p className="label m-0 text-start doNot" style={{ fontSize: '11px', marginTop: '4px' }}>
                    Example: https://www.example.com
                    <span className="float-end">
                      Do not have a url?{" "}
                      <Link
                        to="#"
                        className="link-admin"
                        onClick={(e) => {
                          window.location.href =
                            "mailto:contactus@vikramshilaedu.in";
                        }}
                      >
                        Contact Admin
                      </Link>
                    </span>
                  </p>
                  {urlWarningMsg && !isurlValid && (
                    <p className="url-warning-msg text-danger" style={{ color: "#be1e2d", fontSize: "11px", fontWeight: "600", marginTop: "4px", textAlign: "left" }}>
                      {urlWarningMsg}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div
                  className={`position-relative py-2 ${getClasses(
                    "",
                    "affiliatedDepartment"
                  )}`}
                >
                  <Input
                    className={
                      workSectionValues?.affiliatedDepartment
                        ? "form-control active-input"
                        : "form-control grey-input"
                    }
                    labelClass=""
                    label={
                      workSectionValues.affiliationType === "Company"
                        ? "Designation*"
                        : "Affiliated Department*"
                    }
                    placeholder={
                      workSectionValues.affiliationType === "Company"
                        ? "Designation*"
                        : "Affiliated Department*"
                    }
                    name="affiliatedDepartment"
                    type="text"
                    value={workSectionValues?.affiliatedDepartment}
                    handleChange={(e) => handleChange(e, Sectionindex)}
                    required={
                      isProfessional &&
                      (isRequired(workSectionValues?.affiliatedDepartment) ||
                        isurlValid)
                    }
                    readOnly={!isurlValid}
                  />
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div className={`position-relative py-2 ${getClasses("", "subject")}`}>
                  {Sectionindex === 0 && isJournalDisciplineAutoSet ? (
                    <Input
                      className={
                        (workSectionValues?.subject || autoDisciplineForJournal)
                          ? "form-control active-input"
                          : "form-control grey-input"
                      }
                      labelClass=""
                      label="Primary Discipline *"
                      placeholder="Primary Discipline *"
                      name="subject"
                      type="text"
                      value={workSectionValues?.subject || autoDisciplineForJournal}
                      readOnly={true}
                    />
                  ) : (
                    <Select
                      options={getUnique(
                        masterData?.MasterData?.subjectdata?.map(
                          (val) => val.subjectName
                        ) || []
                      )}
                      name="subject"
                      placeholder={
                        Sectionindex === 0
                          ? "Primary Discipline *"
                          : (Sectionindex === 1 ? "Secondary" : "Tertiary") +
                            " Discipline *"
                      }
                      handleChange={(value) => {
                        handleSelectValue(value, Sectionindex, "subject");
                      }}
                      selectedValue={
                        workSectionValues?.subject &&
                        workSectionValues?.subject !== ""
                          ? workSectionValues?.subject
                          : null
                      }
                      labelClass=""
                      label={
                        Sectionindex === 0
                          ? "Primary Discipline *"
                          : (Sectionindex === 1 ? "Secondary" : "Tertiary") +
                            " Discipline *"
                      }
                      disabled={Sectionindex === 0 && isJournalDisciplineAutoSet ? true : (isurlValid ? false : true)}
                      required={
                        isProfessional &&
                        (isRequired(workSectionValues?.subject) || isurlValid)
                      }
                    />
                  )}
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div className={`position-relative py-2 ${getClasses("", "specialization")}`}>
                  <SearchDropdown
                    options={subjectOptions}
                    handleOtherOption={(data) =>
                      props.handleOthers(data, ind)
                    }
                    handleGetSpecializationOption={() =>
                      props.handleGetSpecialization()
                    }
                    disabled={!isurlValid}
                    index={ind}
                    onChange={handleChange}
                    selectedValue={workSectionValues?.specialization}
                    labelClass=""
                    name="specialization"
                    selected="Subject"
                    subjectId={getSubjectId(workSectionValues?.subject)}
                    placeholder={
                      val?.specialization.length === 0
                        ? "Subject*"
                        : val?.specialization.length > 1
                        ? val?.specialization[0] +
                          " +" +
                          String(val?.specialization.length - 1)
                        : val?.specialization[0]
                    }
                    label="Subject (include upto 3)"
                    required={isProfessional && isRequired()}
                  />
                  {ind === 0 && isurlValid && workSectionValues?.subject && (
                    <div className="somethingMind" style={{ fontSize: '11px', marginTop: '4px', textAlign: 'left' }}>
                      Your subject is not showing?{" "}
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setOther({ show: true, specialization: "", disabled: true });
                          setShowSubject(true);
                        }}
                      >
                        Add Subject
                      </Link>
                    </div>
                  )}
                  {ind === 0 &&
                    otherSubject?.map((sub) => {
                      if (sub?.status === "Pending") {
                        return (
                          <div className="custom_input approvalInput mt-2">
                            <Input
                              readOnly
                              className={
                                "form-control active-input specialization-input"
                              }
                              label={""}
                              value={sub?.specialization}
                              postTextClass={"Pending approval"}
                              disabled
                            />
                          </div>
                        );
                      } else return null;
                    })}
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div className={`position-relative py-2 ${getClasses("", "state")}`}>
                  {profileDetails?.nationality === "outSideIndia" ? (
                    <Select
                      options={countryArray}
                      optionValues={countryArray}
                      name="state"
                      isSearchable={true}
                      selectedValue={workSectionValues?.state}
                      labelClass=""
                      label="Country*"
                      handleChange={(value) => {
                        handleSelectValue(value, Sectionindex, "state");
                        getCountries();
                      }}
                      required={
                        isProfessional && (isRequired() || isurlValid)
                      }
                      placeholder="Select Country*"
                      disabled={isurlValid ? false : true}
                    />
                  ) : (
                    <Select
                      options={Object.keys(StateJson)?.sort()}
                      name="state"
                      selectedValue={workSectionValues?.state}
                      labelClass=""
                      label="State*"
                      handleChange={(value) =>
                        handleSelectValue(value, Sectionindex, "state")
                      }
                      required={
                        isProfessional && (isRequired() || isurlValid)
                      }
                      placeholder="Select State*"
                      disabled={isurlValid ? false : true}
                    />
                  )}
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div className={`position-relative py-2 ${getClasses("", "city")}`}>
                  {profileDetails?.nationality === "outSideIndia" ? (
                    <Input
                      className={
                        workSectionValues?.city
                          ? "form-control active-input"
                          : "form-control grey-input"
                      }
                      labelClass=""
                      label="City*"
                      placeholder="City*"
                      name="city"
                      type="text"
                      value={workSectionValues?.city}
                      handleChange={(e) => handleChange(e, Sectionindex)}
                      required={
                        isProfessional && (isRequired() || isurlValid)
                      }
                      readOnly={!isurlValid}
                    />
                  ) : (
                    <Select
                      options={StateJson?.[workSectionValues?.state]?.sort()}
                      disabled={
                        (workSectionValues?.state ? false : true) &&
                        !isurlValid
                      }
                      placeholder="Select City*"
                      name="city"
                      selectedValue={workSectionValues?.city}
                      handleChange={(value) =>
                        handleSelectValue(value, Sectionindex, "city")
                      }
                      label="City*"
                      labelClass=""
                      required={
                        isProfessional && (isRequired() || isurlValid)
                      }
                    />
                  )}
                </div>
              </div>

              <div className="col-lg-6 mb-4" onClick={handleUnverifiedClick}>
                <div className={`position-relative py-2 ${getClasses("", "pincode")}`}>
                  <Input
                    className={
                      workSectionValues?.pincode
                        ? "form-control active-input"
                        : "form-control grey-input"
                    }
                    labelClass=""
                    label="Pin Code*"
                    placeholder="Pin Code*"
                    name="pincode"
                    type="pin"
                    value={workSectionValues?.pincode}
                    handleChange={(e) => handleChange(e, Sectionindex)}
                    required={isProfessional && (isRequired() || isurlValid)}
                    readOnly={!isurlValid}
                  />
                </div>
              </div>
          {renderLinks && (
            <div className="col-lg-12 mb-2">
              {renderLinks()}
            </div>
          )}
        </div>
      </div>
      {other.show && (
        <OtherSubject
          showSubject={showSubject}
          setShowSubject={setShowSubject}
          props={handleOtherSubject}
          other={other}
          setOther={setOther}
          subjectId={getSubjectId(workSectionValues?.subject)}
          subjectType={"profile"}
        />
      )}
    </>
  );
}
WorkSection.propTypes = {
  profileDetails: PropTypes.shape({
    pincode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    city: PropTypes.string,
    universitySchoolCompany: PropTypes.string,
  }),
  handleChange: PropTypes.func,
  StateJson: PropTypes.object,
  activeTab: PropTypes.string,
  heading: PropTypes.string,
  workSectionValues: PropTypes.object,
  masterData: PropTypes.object,
};

WorkSection.defaultProps = {
  handleChange: () => null,
  profileDetails: {},
  StateJson: {},
  activeTab: "",
  heading: "",
  workSectionValues: {},
  masterData: {},
};

export default WorkSection;
